import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@elkaso-app/web-design';
import { useDeleteInvoiceScanApi } from 'apis/invoice-scanning';
import React, { useCallback } from 'react';

interface DeleteScanModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDeleteSuccess?: () => void;
  scanId: number;
  invoiceNumber: string | null;
  vendorName: string | null;
}

export const DeleteScanModal: React.FC<DeleteScanModalProps> = ({
  isOpen,
  onClose,
  onDeleteSuccess,
  scanId,
  invoiceNumber,
  vendorName,
}) => {
  const { mutate: deleteScan, isLoading: isDeleting } = useDeleteInvoiceScanApi({
    onSuccess: () => {
      onClose();
      onDeleteSuccess?.();
    },
  });

  const handleConfirm = useCallback(() => {
    deleteScan({ scanId });
  }, [deleteScan, scanId]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='md' closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Invoice Scan</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align='start'>
            <Text>Are you sure you want to delete this invoice scan?</Text>

            <VStack spacing={2} align='start' bg='gray.50' p={4} borderRadius='md' w='full'>
              <Text fontSize='sm' color='gray.600'>
                <Text as='span' fontWeight='semibold'>Invoice #:</Text> {invoiceNumber || '---'}
              </Text>
              <Text fontSize='sm' color='gray.600'>
                <Text as='span' fontWeight='semibold'>Vendor:</Text> {vendorName || '---'}
              </Text>
              <Text fontSize='sm' color='gray.600'>
                <Text as='span' fontWeight='semibold'>Scan ID:</Text> {scanId}
              </Text>
            </VStack>

            <Text fontSize='sm' color='red.600' fontWeight='medium'>
              This will soft-delete the scan. The record will no longer appear in the list.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing={3}>
            <Button variant='outline' onClick={onClose} isDisabled={isDeleting}>Cancel</Button>
            <Button colorScheme='red' onClick={handleConfirm} isLoading={isDeleting} loadingText='Deleting...'>
              Delete Scan
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
